import { render, staticRenderFns } from "./clinicsEdit.vue?vue&type=template&id=88881640&"
import script from "./clinicsEdit.vue?vue&type=script&lang=js&"
export * from "./clinicsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports